









































import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import { isWindowSize } from '@/helpers/window-size.helper';
import { EWindowSize } from '@/enums/window-size';

@Component({
  name: 'BaseFixedBottomPrompt',
  components: {
    Icon,
  },
})
export default class BaseFixedBottomPrompt extends Vue {
  @Prop() parentContainer: HTMLElement;
  @Prop() loading: boolean;
  @Ref('promptContainer') promptContainer: HTMLElement;

  promptPosition = 0;
  promptWidthDefault = 842;
  promptWidth = this.promptWidthDefault;
  buttonsVisible = true;

  get showButtons(): boolean {
    return this.buttonsVisible;
  }

  isXSmallDevice(): boolean {
    return isWindowSize(EWindowSize.XSmall);
  }

  toggleButtons() {
    if (!this.isXSmallDevice()) {
      return;
    }
    this.buttonsVisible = !this.buttonsVisible;
  }

  getPromptWidth(parentWidth: number): number {
    if (parentWidth < this.promptWidthDefault) {
      const padding = parseInt(window.getComputedStyle(this.promptContainer).padding);
      return parentWidth - padding * 2;
    }
    return this.promptWidthDefault;
  }

  updatePrompt() {
    this.buttonsVisible = !this.isXSmallDevice();
    window.requestAnimationFrame(() => {
      const { x, width } = this.parentContainer.getBoundingClientRect();
      this.promptPosition = x + width / 2;
      this.promptWidth = this.getPromptWidth(width);
    });
  }

  mounted() {
    this.updatePrompt();
    window.addEventListener('resize', this.updatePrompt);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updatePrompt);
  }
}
